import { BaseBus } from "./BaseBus";
import { DateFunctions } from '../static/date-functions';
import { CommonFunctions } from "../static/common-functions";

 export class ScheduleDispatchBus extends BaseBus
 { 
     constructor(busObj: ScheduleDispatchBus = null) {
         super(busObj);
         this.insertDt = DateFunctions.getDate(this.insertDt);
         this.updateDt = DateFunctions.getDate(this.updateDt);
         this.startDate = DateFunctions.getDate(this.startDate);
     }
     CID(): any {
         return this.scheduleDispatchId;
     }
     setId(id: any) {
         this.scheduleDispatchId = id;
     }
     setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
         if (!DateFunctions.isValidDate(this.insertDt)) {
             this.insertDt = date;
             this.insertUserId = userId;
         }
         this.updateDt = date;
         this.updateUserId = userId;
         if (!CommonFunctions.hasGuidValue(this.companyId)) {
             this.companyId = companyId;
         }
     }
     scheduleDispatchId: any;
     companyId: any;
     dispatchId: any;
     unschedule: boolean;
     startDate: Date;
     scheduleFrequencyId: any;
     scheduleName: string;
     insertDt: Date;
     insertUserId: any;
     updateDt: Date;
     updateUserId: any;
     customerName: string;
     locationName: string;
     dispatchNumber: string;
     everyXMonths: number;
 }
